import type { BoardModel } from './models/board/BoardModel';
import { BoardEventType } from './models/board/BoardEvents';
import type { BoardState } from './types';
import type { TileColor } from './TileColor';

export interface BoardRecordingMove {
  x: number;
  y: number;
  colors: TileColor[];
  output: BoardState;
}

export interface BoardRecording {
  initState: BoardState;
  moves: { x: number; y: number; colors: TileColor[]; output: BoardState }[];
}

export class BoardRecorder {
  private recording: BoardRecording | null = null;

  constructor(private readonly model: BoardModel) {
    model.events.addListener(BoardEventType.MoveMade, async ({ stackId, tiles }) => {
      if (!this.recording) return;

      const stack = model.getStackById(stackId);

      if (!stack) return;

      this.recording.moves.push({
        x: stack.x,
        y: stack.y,
        colors: tiles.map(({ color }) => color),
        output: await this.waitForStateUpdate(),
      });
    });
  }

  public waitForStateUpdate(): Promise<BoardState> {
    return new Promise<BoardState>((resolve) => {
      const callback = (): void => {
        resolve(this.model.exportState());
        this.model.onStateUpdate.disconnect(callback);
      };
      this.model.onStateUpdate.connect(callback);
    });
  }

  public startRecording(): void {
    this.recording = {
      initState: this.model.exportState(),
      moves: [],
    };
  }

  public stop(): BoardRecording | null {
    const { recording } = this;
    if (!recording) return null;
    this.recording = null;
    return recording;
  }
}
